import { matchPath } from 'react-router-dom'

const SSO_CONNECTION_KEY = 'sso_connection'
const SILENT_SSO_LOGIN_KEY = 'sso_silent_login_return_to'
const PASSWORD_LOGIN_PATHS = ['/login', '/create-account']

export const getSsoConnection = (): string | null => localStorage.getItem(SSO_CONNECTION_KEY)

// Set while a silent (`prompt=none`) SSO login is under way, so a "no session" answer can fall back to a normal login
export const startSilentSsoLogin = (returnTo: string): void => sessionStorage.setItem(SILENT_SSO_LOGIN_KEY, returnTo)

export const getSilentSsoLoginReturnTo = (): string | null => sessionStorage.getItem(SILENT_SSO_LOGIN_KEY)

export const endSilentSsoLogin = (): void => sessionStorage.removeItem(SILENT_SSO_LOGIN_KEY)

export const resolveSsoConnection = (pathname: string): string | null => {
  const ssoConnection = matchPath('/login/sso/:connection', pathname)?.params.connection

  if (ssoConnection) {
    localStorage.setItem(SSO_CONNECTION_KEY, ssoConnection)
  } else if (PASSWORD_LOGIN_PATHS.some((path) => matchPath(path, pathname))) {
    localStorage.removeItem(SSO_CONNECTION_KEY)
  }

  return getSsoConnection()
}
